/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useState } from "react";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import { ErrorBoundary } from "react-error-boundary";
import LabelledField from "components/labelled-field";
import { LinkSelectorWrapper } from "cms/links/link-selector/link-selector-wrapper";
import { SimplicityComposerEnsureTipTap } from "cms/rich-text/simplicity-composer-tiptap/index";
import { TextField } from "@mui/material";
import { FieldErrorFallback } from "cms/fields/layout/field-error";
import { TimelineComponentWrapper } from "./component-timeline-wrapper";
import { TimelineSlideEditor } from "./timeline-slide-editor";
// import { useTranslation } from "react-i18next";

const TimelineComponentEditor = () => {
    // const { t } = useTranslation();
    const { component, update } = useUpdateComponent();
    const [linkData, setLinkData] = useState();
    const [loadingLink, setLoadingLink] = useState();

    const { timelines } = component;

    const onChangeList = (timelines) => {
        update("timelines", timelines);
    };

    const onChangeSection = (event) => {
        const section = event.target.value;
        update("section", section);
    };

    const onChangeTitle = (event) => {
        const title = event.target.value;
        update("title", title);
    };

    const onChangeSubtitle = (event) => {
        const subtitle = event.target.value;
        update("subtitle", subtitle);
    };

    const onChangeDescription = (description) => {
        update("description", description);
    };

    const onChangeLink = (link) => {
        setLinkData(link);
        update("link", link);
    };

    const onRemoveLink = () => {
        const link = undefined;
        setLinkData(link);
        update("link", link);
    };

    return (
        <div>
            <ErrorBoundary
                FallbackComponent={FieldErrorFallback}
                onReset={() => {
                    location.reload();
                }}
            >
                <div className="timeline">
                    <div className="timeline-left-section">
                        <LabelledField label="Section Name">
                            <TextField onChange={onChangeSection} fullWidth value={component.section} />
                        </LabelledField>

                        <LabelledField label="Title">
                            <TextField
                                onChange={onChangeTitle}
                                fullWidth
                                value={component.title}
                            />
                        </LabelledField>

                        <LabelledField label="Subtitle">
                            <TextField
                                onChange={onChangeSubtitle}
                                fullWidth
                                value={component.subtitle}
                            />
                        </LabelledField>

                        <LabelledField label="Description">
                            <SimplicityComposerEnsureTipTap
                                richtext={component.description}
                                onChange={onChangeDescription}
                            />
                        </LabelledField>

                        <LabelledField label="Button">
                            <LinkSelectorWrapper
                                onLinkChange={onChangeLink}
                                onLinkRemove={onRemoveLink}
                                link={linkData}
                                setLink={setLinkData}
                                loadingLink={loadingLink}
                                setLoadingLink={setLoadingLink}
                                disabled={false}
                            />
                        </LabelledField>
                    </div>
                    <div className="timeline-right-section">
                        <div className="simplicity-timeline-list-wrapper">
                            <TimelineComponentWrapper
                                timelines={timelines}
                                onChangeList={onChangeList}
                            >
                                <TimelineSlideEditor />
                            </TimelineComponentWrapper>
                        </div>
                    </div>
                </div>
            </ErrorBoundary>
        </div>
    );
};
TimelineComponentEditor.displayName = "TimelineComponentEditor";
export { TimelineComponentEditor };
